export default __webpack_public_path__ + "static/media/Destination5.61c7f6da.png";